module.exports = __webpack_public_path__ + "static/farm-to-pantry-7b0ecb4b52c416bbd6fdc2a7d32e3086.jpg";